module.exports = __webpack_public_path__ + "img/page_image_3_2.86584596.svg";